import { Api } from '../hooks/useApi';
import { UtmifyOrderStatus } from '../types/utmify-event';
import { getUtmifyTrackingParameters } from './get-utmify-tracking-parameters';

const DEFAULT_UTMIFY_WAIT_MS = 3000;

export const emitUtmifyEvent = async (input: {
  vendaId: string;
  event: UtmifyOrderStatus;
}) => {
  const api = new Api();
  try {
    const { event, vendaId } = input;
    const response = await api.Produto.emitUtmify({
      parameters: getUtmifyTrackingParameters(vendaId),
      vendaId,
      event,
    });
    return response.data;
  } catch (e) {
    console.error('Erro no tracking do UTMify:', e);
  }
};

export async function awaitEmitUtmifyEvent(
  input: {
    vendaId: string;
    event: UtmifyOrderStatus;
  },
  opts?: { budgetMs?: number },
): Promise<void> {
  if (!input.vendaId) return;
  const budgetMs = opts?.budgetMs ?? DEFAULT_UTMIFY_WAIT_MS;
  const deadline = new Promise<void>((resolve) => {
    setTimeout(resolve, budgetMs);
  });
  await Promise.race([emitUtmifyEvent(input), deadline]);
}
